module.exports = __webpack_public_path__ + "static/media/android-app.737bec95.png";